









import { Vue, Component,Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { StoreState } from '../../../store';


 @Component({
    mounted: function() {
      
    },
    computed: {
        ...mapState({
         monthyears: (state: StoreState) => state.reports.monthyear
        })
    },
    watch: {
        cdrs(newVal, oldVal) {
             console.log(newVal);
            this.$data.monthyears = newVal;
           (this.$refs.monthyear as any).data=newVal;
            (this.$refs.monthyear as any).refresh();
            (this.$refs.monthyear as any).selectedIndex=0;
            
           
        }
    }
})

export default class monthrange extends Vue {
    data() {
        return [];
    }

    monthChanged($event: any) {
        let monthindex  =($event as any).currentTarget.selectedIndex;
        //let monthindex = (this.$refs.monthyear as any).selectedIndex;
         this.$store.dispatch('getCallReports', {para:{ shouldContinue: false , Page:1, monthindex:monthindex}});
    }
}
